import React, { useEffect } from 'react';

import { Modal } from '@components/common';
import FlatTreeXML from '@components/common/FlatXMLTree';
import { TFlatTreeSetData } from '@components/common/FlatXMLTree/FlatTreeXML';

import {
	useQueryChangesMonitoringUpdateString,
} from '@hooks/networkElementConfigurations/useQueryChangesMonitoringUpdateString';

import {
	IChangeMonitoring,
} from '@interfaces/networkElementConfigurations/networkElementConfigurations';
import { TMapTree } from '@components/common/FlatXMLTree/interface';

import { MODAL_WIDTH_1000 } from '@constants/modals';

export default function ViewChanges({
	onClose,
	networkElement,
}: {
	onClose: () => void;
	networkElement: IChangeMonitoring;
}) {
	const [treeData, setTreeData] = React.useState<TMapTree | null>(null);

	const {
		isUpdateStringLoading,
		data,
	} = useQueryChangesMonitoringUpdateString({
		id: networkElement.id,
	});

	useEffect(() => {
		if (data) {
			setTreeData(data.tree);
		}
	}, [data]);

	return (
		<Modal
			height='85vh'
			isConfirmDialogNeededOnClose
			isDirtyForm={false}
			isLoading={isUpdateStringLoading}
			isOpen
			onClose={onClose}
			title='View parameter'
			width={MODAL_WIDTH_1000}
		>
			<FlatTreeXML
				data={treeData || new Map()}
				isReadOnly={true}
				setData={setTreeData as unknown as TFlatTreeSetData}
				withSearch={false}
			/>
		</Modal>
	);
}
